var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartagerContour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7479697B-E8C2-455F-B546-E5D8834365B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-215.000000, -787.000000)",
    fill: "#0E3E28",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(0.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(215.503894, 62.000025)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 3.16405092 5.3320302 3.16405092 5.3320302 4.82811132 0.332030199 4.82811132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 12.1640509 5.3320302 12.1640509 5.3320302 13.8281113 0.332030199 13.8281113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 21.1640509 5.3320302 21.1640509 5.3320302 22.8281113 0.332030199 22.8281113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(0.832030, 12.996081) rotate(90.000000) translate(-0.832030, -12.996081) ",
    points: "-9 12.1640509 10.6640604 12.1640509 10.6640604 13.8281113 -9 13.8281113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9960843,0 L6.8320302,0 C6.16898665,0 5.53310268,0.263391768 5.06426232,0.732232122 C4.59542197,1.20107248 4.3320302,1.83695646 4.3320302,2.5 L4.3320302,5 C4.3320302,6.38070382 5.45131691,7.5 6.8320302,7.5 L16.9960843,7.5 C18.3767944,7.5 19.4960811,6.38070382 19.4960811,5 L19.4960811,2.5 C19.4960811,1.11928671 18.3767944,0 16.9960843,0 L10.9960843,0 Z M17.8320207,4.99999368 C17.8320207,5.46166863 17.4577592,5.83593013 16.9960906,5.83593013 L6.83202704,5.83593013 C6.37035209,5.83593013 5.9960906,5.46166863 5.9960906,4.99999368 L5.9960906,2.49999684 C5.9960906,2.03832189 6.37035209,1.6640604 6.83202704,1.6640604 L16.9960906,1.6640604 C17.4577592,1.6640604 17.8320207,2.03832189 17.8320207,2.49999684 L17.8320207,4.99999368 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9960843,9 L6.8320302,9 C6.16898665,9 5.53310268,9.26339177 5.06426232,9.73223212 C4.59542197,10.2010725 4.3320302,10.8369565 4.3320302,11.5 L4.3320302,14 C4.3320302,15.3807038 5.45131691,16.5 6.8320302,16.5 L16.9960843,16.5 C18.3767944,16.5 19.4960811,15.3807038 19.4960811,14 L19.4960811,11.5 C19.4960811,10.1192867 18.3767944,9 16.9960843,9 L10.9960843,9 Z M17.8320207,13.9999937 C17.8320207,14.4616686 17.4577592,14.8359301 16.9960906,14.8359301 L6.83202704,14.8359301 C6.37035209,14.8359301 5.9960906,14.4616686 5.9960906,13.9999937 L5.9960906,11.4999968 C5.9960906,11.0383219 6.37035209,10.6640604 6.83202704,10.6640604 L16.9960906,10.6640604 C17.4577592,10.6640604 17.8320207,11.0383219 17.8320207,11.4999968 L17.8320207,13.9999937 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9960843,18 L6.8320302,18 C6.16898665,18 5.53310268,18.2633918 5.06426232,18.7322321 C4.59542197,19.2010725 4.3320302,19.8369565 4.3320302,20.5 L4.3320302,23 C4.3320302,24.3807038 5.45131691,25.5 6.8320302,25.5 L16.9960843,25.5 C18.3767944,25.5 19.4960811,24.3807038 19.4960811,23 L19.4960811,20.5 C19.4960811,19.1192867 18.3767944,18 16.9960843,18 L10.9960843,18 Z M17.8320207,22.9999937 C17.8320207,23.4616686 17.4577592,23.8359301 16.9960906,23.8359301 L6.83202704,23.8359301 C6.37035209,23.8359301 5.9960906,23.4616686 5.9960906,22.9999937 L5.9960906,20.4999968 C5.9960906,20.0383219 6.37035209,19.6640604 6.83202704,19.6640604 L16.9960906,19.6640604 C17.4577592,19.6640604 17.8320207,20.0383219 17.8320207,20.4999968 L17.8320207,22.9999937 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartagerContour);
export default __webpack_public_path__ + "static/media/partager-contour.76ca218e2f44e97f15f358d8a22d82ea.svg";
export { ForwardRef as ReactComponent };